// @ts-check
/**
 * Frontend entry point.
 *
 * Two-phase boot:
 *   1. Pull in socket.io client (served by the socket.io server, NOT bundled
 *      by Vite). Done dynamically so Vite never tries to resolve it. This
 *      exposes `window.io` for sockets.js below.
 *   2. Once `window.io` exists, dynamic-import bootstrap.js which contains
 *      every other static import. Vite bundles that whole graph into a single
 *      chunk, so this is ONE extra HTTP request, not many.
 */

/**
 * Inject the socket.io client script and resolve once `window.io` is wired up.
 * @returns {Promise<void>}
 */
function loadSocketIo() {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = '/socket.io/socket.io.js';
    s.async = false;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Failed to load /socket.io/socket.io.js'));
    document.head.appendChild(s);
  });
}

await loadSocketIo();
await import('./bootstrap.js');
